module.exports = "#version 300 es\nprecision highp float;\n\nin vec4 fs_Col;\nin vec4 fs_Pos;\n\nout vec4 out_Col;\n\nvoid main()\n{\n\n    float z = fs_Pos.z * (2.0 - fs_Pos.y / 15.0);\n    float y = 1.3 * fs_Pos.y - abs(fs_Pos.x) * sqrt(1.0 - abs(fs_Pos.x));\n    vec3 p2 = vec3(fs_Pos.x, y, fs_Pos.z);\n    float dist = 1.0 - length(p2.xyz) - 0.5;\n    out_Col = vec4(dist) * fs_Col;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/particle-frag.glsl
// module id = 72
// module chunks = 0